import { Eyebrow, Reveal, SectionTitle } from "./Reveal";
import { EXPERIENCES } from "./data";

export default function Experiences() {
  return (
    <section data-testid="experiences-section" className="border-y border-ink/10 bg-sand">
      <div className="mx-auto max-w-editorial px-6 py-24 md:px-10 md:py-32">
        <Reveal>
          <Eyebrow center>Optional</Eyebrow>
        </Reveal>
        <Reveal delay={0.12}>
          <SectionTitle before="The Quiet" accent="Extras" center className="mt-7" />
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-6 max-w-md text-center text-sm leading-[1.85] text-fog">
            Arranged on request and simply added to your final quote.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-5 md:grid-cols-2">
          {EXPERIENCES.map((exp, i) => (
            <Reveal
              key={exp.title}
              delay={(i % 2) * 0.08}
              className={`group border border-ink/10 bg-cream p-7 transition-all duration-500 hover:border-saffron/50 hover:shadow-md md:p-8 ${
                i === EXPERIENCES.length - 1 && EXPERIENCES.length % 2 === 1 ? "md:col-span-2 md:mx-auto md:max-w-[50%]" : ""
              }`}
            >
              <div data-testid={`experience-${i}`} className="flex items-start gap-6">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-saffron/15 font-serif text-lg italic text-saffron">
                  0{i + 1}
                </span>
                <div>
                  <h3 className="font-serif text-xl font-light leading-snug text-ink transition-colors duration-300 group-hover:text-leaf md:text-2xl">
                    {exp.title}
                  </h3>
                  {exp.price && (
                    <p className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.26em] text-saffron">{exp.price}</p>
                  )}
                  <p className="mt-2 text-[13.5px] leading-[1.85] text-fog">{exp.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
